import { useState, useEffect } from "react";
import ServiceCard from "./ServiceCard";
import { useParams } from "react-router-dom";
import { reviewService } from "../../services/review.service";
export function ServiceList({ services, theme }) {
  const { bussinessUuid } = useParams();
  const [reviewStatsByService, setReviewStatsByService] = useState({});

  useEffect(() => {
    let cancelled = false;

    const loadReviewStats = async () => {
      if (!bussinessUuid || !Array.isArray(services) || services.length === 0) {
        setReviewStatsByService({});
        return;
      }

      const entries = await Promise.all(
        services.map(async (service) => {
          const serviceId = service?.serviceId || service?._id;
          if (!serviceId) return null;

          try {
            const response = await reviewService.getProductReviewStats(bussinessUuid, serviceId);
            const stats = response?.data || {};
            return [
              serviceId,
              {
                averageRating: Number(stats?.averageRating || 0),
                totalReviews: Number(stats?.totalReviews || 0),
              },
            ];
          } catch (error) {
            return [serviceId, { averageRating: 0, totalReviews: 0 }];
          }
        })
      );
      if (cancelled) return;
      const mapped = {};
      entries.filter(Boolean).forEach(([serviceId, stats]) => {
        mapped[serviceId] = stats;
      });
      setReviewStatsByService(mapped);
    };

    loadReviewStats();

    return () => {
      cancelled = true;
    };
  }, [bussinessUuid, services]);
  return (
    <>
      <div className="space-y-6">
        <div className="rounded-3xl border border-slate-200 bg-white/80 p-5 shadow-sm backdrop-blur">
          <div className="flex flex-col gap-2 md:flex-row md:items-end md:justify-between">
            <div>
              <p className="text-sm font-semibold uppercase tracking-[0.25em] text-blue-600">Online services</p>
              <h2 className="text-2xl font-semibold text-slate-900">Reserve your preferred service in a few taps</h2>
            </div>
            <p className="max-w-xl text-sm text-slate-500">Choose a date, pick an employee and secure your slot instantly for both fixed-price and time-based services.</p>
          </div>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
          {services.map((service) => (
            <ServiceCard
              key={service._id || service.serviceName}
              product={service}
              theme={theme}
              reviewStats={reviewStatsByService[service?.serviceId || service?._id]}
            />
          ))}
        </div>
      </div>
    </>
  );
}